import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var HeadingStatus;

(function (HeadingStatus) {
  HeadingStatus["New"] = "New";
  HeadingStatus["Update"] = "Update";
  HeadingStatus["Deactivate"] = "Deactivate";
})(HeadingStatus || (HeadingStatus = {}));

export var NoneValue = 'none';
/**
 * Form-release APIs append `#{version}` to link IDs (e.g. `uuid#15`, `none#15`).
 * Draft form-edit IDs have no suffix. Strip it so linked-list comparisons match.
 */

export var normalizeLinkedEntityId = function normalizeLinkedEntityId(id) {
  var _id$split$;

  if (!id) {
    return NoneValue;
  }

  var base = ((_id$split$ = id.split('#')[0]) === null || _id$split$ === void 0 ? void 0 : _id$split$.trim()) || '';

  if (!base || base.toLowerCase() === NoneValue) {
    return NoneValue;
  }

  return base;
};
export var linkedEntityIdsEqual = function linkedEntityIdsEqual(left, right) {
  return normalizeLinkedEntityId(left) === normalizeLinkedEntityId(right);
};
export var isNoneLinkedEntityId = function isNoneLinkedEntityId(id) {
  return normalizeLinkedEntityId(id) === NoneValue;
};
export var Heading = /*#__PURE__*/function (_Entity) {
  _inherits(Heading, _Entity);

  var _super = _createSuper(Heading);

  function Heading() {
    _classCallCheck(this, Heading);

    return _super.apply(this, arguments);
  }

  _createClass(Heading, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "nextQuestionId",
    get: function get() {
      return normalizeLinkedEntityId(this.props.nextQuestionId);
    }
  }, {
    key: "previousHeadingId",
    get: function get() {
      return normalizeLinkedEntityId(this.props.previousHeadingId);
    }
  }, {
    key: "nextHeadingId",
    get: function get() {
      return normalizeLinkedEntityId(this.props.nextHeadingId);
    }
  }, {
    key: "previousQuestionId",
    get: function get() {
      return normalizeLinkedEntityId(this.props.previousQuestionId);
    }
  }, {
    key: "status",
    get: function get() {
      var _this$props$status;

      return (_this$props$status = this.props.status) !== null && _this$props$status !== void 0 ? _this$props$status : HeadingStatus.New;
    }
  }, {
    key: "type",
    get: function get() {
      var _this$props$type;

      return (_this$props$type = this.props.type) !== null && _this$props$type !== void 0 ? _this$props$type : 'heading';
    }
  }, {
    key: "sectionId",
    get: function get() {
      var _this$props$sectionId;

      return (_this$props$sectionId = this.props.sectionId) !== null && _this$props$sectionId !== void 0 ? _this$props$sectionId : '';
    }
  }, {
    key: "formId",
    get: function get() {
      var _this$props$formId;

      return (_this$props$formId = this.props.formId) !== null && _this$props$formId !== void 0 ? _this$props$formId : '';
    }
  }, {
    key: "aiChangeType",
    get: function get() {
      return this.props.aiChangeType;
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(title) {
      this.props.title = title;
      return Result.ok();
    }
  }, {
    key: "updateDescription",
    value: function updateDescription(description) {
      this.props.description = description;
      return Result.ok();
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(status) {
      this.props.status = status;
      return Result.ok();
    }
  }, {
    key: "updatePreviousHeadingId",
    value: function updatePreviousHeadingId(previousHeadingId) {
      this.props.previousHeadingId = previousHeadingId;
      return Result.ok();
    }
  }, {
    key: "updateNextHeadingId",
    value: function updateNextHeadingId(nextHeadingId) {
      this.props.nextHeadingId = nextHeadingId;
      return Result.ok();
    }
  }, {
    key: "updatePreviousQuestionId",
    value: function updatePreviousQuestionId(previousQuestionId) {
      this.props.previousQuestionId = previousQuestionId;
      return Result.ok();
    }
  }, {
    key: "updateNextQuestionId",
    value: function updateNextQuestionId(nextQuestionId) {
      this.props.nextQuestionId = nextQuestionId;
      return Result.ok();
    }
  }, {
    key: "updateSectionId",
    value: function updateSectionId(sectionId) {
      this.props.sectionId = sectionId;
      return Result.ok();
    }
  }, {
    key: "deActivate",
    value: function deActivate() {
      this.props.status = HeadingStatus.Deactivate;
      return Result.ok();
    }
  }, {
    key: "clone",
    value: function clone() {
      var clonedProps = {
        title: this.title,
        description: this.description,
        previousQuestionId: this.previousQuestionId,
        nextQuestionId: this.nextQuestionId,
        previousHeadingId: this.previousHeadingId,
        nextHeadingId: this.nextHeadingId,
        status: this.status,
        type: this.type,
        sectionId: this.sectionId,
        formId: this.formId
      };
      return Heading.create(clonedProps, this.id.toString()).getValue();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var _props$status, _props$type;

      var guardCollections = [{
        argument: props.title,
        argumentName: 'Heading Title'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        previousHeadingId: normalizeLinkedEntityId(props.previousHeadingId),
        nextHeadingId: normalizeLinkedEntityId(props.nextHeadingId),
        nextQuestionId: normalizeLinkedEntityId(props.nextQuestionId),
        previousQuestionId: normalizeLinkedEntityId(props.previousQuestionId),
        status: (_props$status = props.status) !== null && _props$status !== void 0 ? _props$status : HeadingStatus.New,
        type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'heading'
      });

      return Result.ok(new Heading(defaultProps, new UniqueEntityID(id)));
    }
  }, {
    key: "isTopHeading",
    value: function isTopHeading(heading) {
      return isNoneLinkedEntityId(heading.previousHeadingId);
    }
  }, {
    key: "isBottomHeading",
    value: function isBottomHeading(heading) {
      return isNoneLinkedEntityId(heading.nextHeadingId);
    }
  }]);

  return Heading;
}(Entity);